module.exports = __webpack_public_path__ + "img/videoManagement.5fb593ec.png";